import React from 'react';
import { Popover } from 'antd';
import { observer } from 'mobx-react';
import { WeaLocaleProvider } from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;
export interface PopoverTipsProps {
    error: { visible: boolean, msg: string };
    type: string;
    label: string
}
@observer
export default class PopoverTips extends React.Component<PopoverTipsProps, any> {
    render() {
        let { label, error } = this.props;
        return (
            <Popover ecId={`${this && this.props && this.props.ecId || ''}_Popover@mc4517`}
                placement="bottomLeft"
                overlayClassName="cube-card-waring"
                visible={error.visible}
                content={[<i className="anticon anticon-exclamation-circle" style={{ paddingRight: 5, color: '#f5222d' }} />,
                <span style={{ color: '#fe4042',fontWeight:700, paddingRight: 5, }}>"{label}"</span>,
                <span>{
                    error.msg &&( error.msg.replace(label, '').indexOf("needAdd")>-1 ?  getLabel('383709', "未新增数据"):(error.msg.replace(label, '') ? getLabel(21423, "未填写"):""))
                }</span>]}
            >
                {this.props.children}
            </Popover>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/PopoverTips.tsx